// extracted by mini-css-extract-plugin
export default {"place":"TablePlace_place__6SJdT"};